function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _templateObject, _templateObject2;
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var Title = styled.div.withConfig({
  displayName: "SrriScale__Title",
  componentId: "sc-10k9ma-0"
})(["color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.descriptionListTermsTextColor;
});
var Step = styled.div.withConfig({
  displayName: "SrriScale__Step",
  componentId: "sc-10k9ma-1"
})(["width:", ";height:", ";border-right:1px solid ", ";margin-right:0;cursor:default;background-color:", ";font-size:", ";line-height:", ";color:", ";text-align:center;&:last-child{border-right:none;}", " ", " ", ""], function (props) {
  return "".concat(props.width, "px");
}, function (props) {
  return "".concat(props.height, "px");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.srriLevelBorderColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.srriLevelBackgroundColor;
}, function (props) {
  return "".concat(props.fontSize);
}, function (props) {
  return "".concat(props.lineHeight, "px");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.srriLevelTextColor;
}, function (props) {
  return props.checked && css(["background-color:", ";color:", ";"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.srriLevelBackgroundColorActive;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.srriLevelTextColorActive;
  });
}, function (props) {
  return !props.compact && css(["margin-right:9px;"]);
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (props) {
  return props.fluid && css(["width:100vw;height:14.2vw;line-height:14.2vw;"]);
}));
var Steps = styled.div.withConfig({
  displayName: "SrriScale__Steps",
  componentId: "sc-10k9ma-2"
})(["display:inline-flex;border:1px solid ", ";border-radius:", ";margin:4px auto;", ""], function (_ref7) {
  var theme = _ref7.theme;
  return theme.srriLevelBorderColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.srriBorderRadius;
}, maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (props) {
  return props.fluid && css(["width:100%;display:flex;"]);
}));
var map = {
  tiny: {
    width: 14,
    height: 14,
    lineHeight: 14,
    fontSize: '0.6rem'
  },
  xsmall: {
    width: 18,
    height: 18,
    lineHeight: 18,
    fontSize: '0.75rem'
  },
  small: {
    width: 24,
    height: 24,
    lineHeight: 24,
    fontSize: '0.8rem'
  },
  medium: {
    width: 32,
    height: 32,
    lineHeight: 32,
    fontSize: '1rem'
  },
  large: {
    width: 48,
    height: 48,
    lineHeight: 48,
    fontSize: '1rem'
  }
};
var SrriScale = function (_React$Component) {
  _inherits(SrriScale, _React$Component);
  var _super = _createSuper(SrriScale);
  function SrriScale() {
    _classCallCheck(this, SrriScale);
    return _super.apply(this, arguments);
  }
  _createClass(SrriScale, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        value = _this$props.value,
        size = _this$props.size,
        compact = _this$props.compact;
      var withTitle = Boolean(this.props.withTitle);
      var variables = map[size];
      return React.createElement(Fragment, null, withTitle ? React.createElement(Title, {
        small: true
      }, "Nivel de riesgo") : '', React.createElement(Steps, {
        fluid: this.props.fluid || false
      }, [1, 2, 3, 4, 5, 6, 7].map(function (item, index) {
        return React.createElement(Step, {
          compact: compact,
          fluid: _this.props.fluid || false,
          key: index,
          checked: item === value,
          width: variables.width,
          height: variables.height,
          lineHeight: variables.lineHeight,
          fontSize: variables.fontSize
        }, item);
      })));
    }
  }]);
  return SrriScale;
}(React.Component);
_defineProperty(SrriScale, "defaultProps", {
  compact: true
});
export { SrriScale as default };